export default function booleanToNumber(bool) {
  return bool ? 1 : 0;
}
